export default "__VITE_ASSET__Bz2fjKS5__"